module.exports = __webpack_public_path__ + "img/font-minus.2d56ac62.svg";